import { render } from "./SvgLogoFooter.vue?vue&type=template&id=267d6f54"
const script = {}

import exportComponent from "/home/gitlab-runner/builds/Szyc6_z_/0/o-line/cabinet_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__